import TinymceCustomButtons from './tinymce-custom-buttons/tinymce-custom-buttons.js'

class TinymceConfigurator {
	#availableCustomButtons
	#customButtonClasses = [];

	async init(editorElement) {
		if (editorElement.dataset.tinymceInitialized) return;
		editorElement.dataset.tinymceInitialized = "1";

		if (!window.tinymce) return console.warn('TinyMCE není dostupný.');
		if (window.tinymce.majorVersion !== '7') return console.warn('TinyMCE v7 není dostupný.');

		const response = await TinymceCustomButtons();
		this.#availableCustomButtons = response.buttons;
		this.#customButtonClasses = response.buttonClasses;

		const rawButtonList = this.#getButtonListFromElement(editorElement);
		const validatedButtonList = this.#validateRawButtonList(rawButtonList);

		window.tinymce.remove('#' + editorElement.id);
		window.tinymce.init({
			...this.#getBaseConfig(editorElement, validatedButtonList),
			setup: (editor) => {
				this.#registerButtons(editor, validatedButtonList);

				if (this.#customButtonClasses.length > 0) {
					editor.on('init', () => {
						this.#setDescription(editor, validatedButtonList);
					})
				}
			}
		}).then(editors => {
			const editor = editors[0];
			const element = editor.dom.select('p')[1];
			if (element) {
				editor.selection.setCursorLocation(element, element.childNodes.length);
			}
		});
	}

	#getButtonListFromElement(element) {
		return (element.dataset.ctTinymceCustomButtons || '').split(' ').filter(Boolean);
	}

	#getBaseConfig(element, buttonList) {
		return {
			license_key: `gpl`,
			promotion: false,
			selector: `#${element.id}`,
			menubar: false,
			autosave_ask_before_unload: true,
			autosave_interval: `30s`,
			plugins: `link lists code autosave autoresize`,
			toolbar: `bold italic strikethrough bullist numlist link unlink code removeformat | ${this.#getToolbarItems(buttonList)}`,
			toolbar_mode: `sliding`,
			entities: `224,agrave,178,sup2,188,frac¼,189,frac½,190,frac¾`,
			entity_encoding: `named`,
			noneditable_regexp: /\{\{[^\}]+\}\}/g,
			content_style: `.mceNonEditable {background-color: rgba(0, 0, 0, 0.15); border-radius: 0.5rem; padding: 0.125rem 0.25rem; font-size: 0.7rem; color: rgba(0, 0, 0, 0.75); display: inline-flex; align-items: center;}`,
			document_base_url: `https://www.centrumtance.cz/`,
			convert_urls: false,
		};
	}

	#registerButtons(editor, buttonList) {
		editor.ui.registry.addIcon('ct-icon', '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" focusable="false" viewBox="0 0 535 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M534.7 215.5V123.6H427.8V0H321.4V358.4c0 30.4 3 54.4 9 72.3a107.5 107.5 0 0 0 30.8 46.1 120.4 120.4 0 0 0 48.7 26.9c17.5 4.7 44.1 6.8 79.6 6.8h44.4V417.3H501.4c-17.1 0-30-.9-37.6-3a44.8 44.8 0 0 1 -21-12.8q-15.4-15.4-15.4-53.9V215.5zM233.9 410.9c-39.7 0-70.1-9-91.1-26.5s-31.2-43.2-31.2-77A92.4 92.4 0 0 1 147 232.2q30.8-25.6 88.5-25.6h39.3v-92H202.5c-32.5 0-60.8 4.7-83.8 13.7A164.2 164.2 0 0 0 55.9 171.9 197.2 197.2 0 0 0 15.7 236 186.8 186.8 0 0 0 .3 309.1a196.7 196.7 0 0 0 15.4 76.1 195.9 195.9 0 0 0 41.9 64.5 171.4 171.4 0 0 0 64.6 41.9c23.1 8.1 53 12 90.2 12h62.4V410.5H233.9z"/></svg>');
		/*
				if (buttonList.length === 1) {
					// Pouze jedno tlačítko – přidáme jako samostatný button
					const btn = buttonList[0];
					const def = this.#availableCustomButtons[btn];
					editor.ui.registry.addButton(btn, {
						icon: 'ct-icon',
						text: def.text,
						onAction: () => def.onAction(editor)
					});
				} else if (buttonList.length > 1) {
					// Více tlačítek – vytvoříme dropdown
		*/
		editor.ui.registry.addMenuButton('ctInsertMenu', {
			icon: 'ct-icon',
			text: 'Vložit',
			fetch: (callback) => {
				console.warn(this.#availableCustomButtons);
				const items = buttonList
					.map(btn => {
						const def = this.#availableCustomButtons[btn];
						if (!def) return null;
						return {
							type: 'menuitem',
							text: def.text,
							onAction: () => def.onAction(editor)
						};
					})
					.filter(Boolean);
				callback(items);
			}
		});
		/*
				}
		*/
	}

	#getToolbarItems(buttonList) {
		/*
				// jedno tlačítko
				if (buttonList.length === 1) return buttonList[0];
				// více tlačítek
				if (buttonList.length > 1) return 'ctInsertMenu';
		*/
		if (buttonList.length > 0) return 'ctInsertMenu';
		return ''; // žádný validní button
	}

	#validateRawButtonList(rawButtonList) {
		return rawButtonList.filter(btn => {
			if (!this.#availableCustomButtons[btn]) {
				console.warn(`[TinyMCEEditor] Tlačítko "${btn}" nebylo definováno v availableCustomButtons.`);
				return false;
			}
			return true;
		});
	}

	#setDescription(editor, validatedButtonList) {
		const container = document.createElement('div');
		container.className = 'placeholder-descriptions';
		const editorContainer = editor.getContainer();
		editorContainer.parentNode.insertBefore(container, editorContainer.nextSibling);

		const relevantDescriptions = this.#customButtonClasses.filter(item =>
			validatedButtonList.includes(item.id)
		);

		const descriptions = relevantDescriptions
			.map(PlaceholderClass => ({
				text: PlaceholderClass.description,
				placeholder: PlaceholderClass.placeholderText
			}))
			.filter(desc => desc.text); // odfiltrujeme undefined descriptions

		if (descriptions.length === 0) {
			container.style.display = 'none';
			return;
		}

		container.innerHTML = `
			<div class="placeholder-help small mt-1 ms-2">
				<strong>Nápověda:</strong>
				<ul>
					${descriptions.map(desc =>
			`<li><span style="background-color: rgba(0, 0, 0, 0.15); border-radius: 0.5rem; padding: 0.125rem 0.25rem; font-size: 0.7rem; color: rgba(0, 0, 0, 0.75); display: inline-flex; align-items: center;">${desc.placeholder}</span> - ${desc.text}</li>`
		).join('')}
				</ul>
			</div>
		`;
		container.style.display = 'block';
	}
}

export default new TinymceConfigurator();